// extracted by mini-css-extract-plugin
export default {"wrapper":"media_wrapper__z+dbX","errorMessage":"media_errorMessage__BVjZP","presentationExistsIcon":"media_presentationExistsIcon__-XNxh"};